import * as React from 'react';

const TickIcon = ({fillColor = '#fff'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={12} height={8} fill="none">
    <path
      stroke={fillColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10.448 1.375 4.694 6.99 1.625 3.995"
    />
  </svg>
);

export default TickIcon;
